import { useSelector } from 'react-redux';
import { PATH } from '../../../routes';
import { webConfig } from '../../../webConfig';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';

interface RouteConfig {
    previous: string;
    next: string;
}

export const useRouteConfig = (path: string): RouteConfig => {
    const { searchUIEnabled } = useSelector((state: AppState) => ({
        searchUIEnabled: state.FeatureFlagging.features[Features.SEARCH_UI_V2],
    }));

    switch (path) {
        case PATH.SIGNUP.HOME:
            return {
                previous: '',
                next: PATH.SIGNUP.WELCOME,
            };
        case PATH.SIGNUP.WELCOME:
            return {
                previous: PATH.SIGNUP.HOME,
                next: PATH.SIGNUP.STEPS.ONE,
            };
        case PATH.SIGNUP.STEPS.ONE:
            return {
                previous: PATH.SIGNUP.WELCOME,
                next: PATH.SIGNUP.STEPS.SEARCH_ORGANIZATION,
            };
        case PATH.SIGNUP.STEPS.SEARCH_ORGANIZATION:
            return {
                previous: PATH.SIGNUP.STEPS.ONE,
                next: PATH.SIGNUP.STEPS.TWO,
            };
        case PATH.SIGNUP.STEPS.ADD_ORGANIZATION:
            return {
                previous: searchUIEnabled
                    ? PATH.SIGNUP.STEPS.ONE
                    : PATH.SIGNUP.STEPS.SEARCH_ORGANIZATION,
                next: PATH.SIGNUP.STEPS.TWO,
            };
        case PATH.SIGNUP.STEPS.INVITE_DONEE:
            return {
                previous: searchUIEnabled
                    ? PATH.SIGNUP.STEPS.CONFIRM_ORGANIZATION
                    : PATH.SIGNUP.STEPS.SEARCH_ORGANIZATION,
                next: PATH.SIGNUP.STEPS.ONE,
            };
        case PATH.SIGNUP.STEPS.CONFIRM_ORGANIZATION:
            return {
                previous: PATH.SIGNUP.STEPS.ONE,
                next: PATH.SIGNUP.STEPS.TWO,
            };
        case PATH.SIGNUP.STEPS.TWO:
            return {
                previous: PATH.SIGNUP.STEPS.ONE,
                next: PATH.SIGNUP.STEPS.THREE,
            };
        case PATH.SIGNUP.STEPS.THREE:
            return {
                previous: PATH.SIGNUP.STEPS.TWO,
                next: PATH.SIGNUP.STEPS.FOUR,
            };
        case PATH.SIGNUP.STEPS.FOUR:
            return {
                previous: PATH.SIGNUP.STEPS.THREE,
                next: PATH.SIGNUP.STEPS.FIVE,
            };
        case PATH.SIGNUP.STEPS.FIVE:
            return {
                previous: PATH.SIGNUP.STEPS.FOUR,
                next: PATH.SIGNUP.STEPS.SIX,
            };
        case PATH.SIGNUP.STEPS.SIX:
            return {
                previous: PATH.SIGNUP.STEPS.FIVE,
                next: PATH.SIGNUP.STEPS.FINAL_STEP,
            };
        case PATH.SIGNUP.STEPS.SEVEN:
            return {
                previous: PATH.SIGNUP.STEPS.SIX,
                next: PATH.SIGNUP.STEPS.FINAL_STEP,
            };
        case PATH.SIGNUP.STEPS.FINAL_STEP:
            return {
                previous: PATH.SIGNUP.STEPS.SIX,
                next: PATH.SIGNUP.STEPS.PASSWORD_STEP,
            };
        case PATH.SIGNUP.STEPS.PASSWORD_STEP:
            return {
                previous: PATH.SIGNUP.STEPS.FINAL_STEP,
                next: PATH.SIGNUP.SUBMITTED,
            };
        case PATH.SIGNUP.SUBMITTED:
            return {
                previous: PATH.SIGNUP.STEPS.PASSWORD_STEP,
                next: webConfig.givelifySignInPageUrl,
            };

        default:
            return {
                next: '',
                previous: '',
            };
    }
};
